<template>

  <t-report-generate
      v-model="form"
      sub-validation-tag="sub-checklist-report-extract-by-checklist"
      default-excel
      modal
      enable-generate-pdf
      enable-generate-excel
      enable-generate-word
      java-report
      button-title="Extrato"
      title="Extrato de Inspeções Realizadas">

    <t-input-search v-model="form.issueDate" date enable-range
                    label="Data Inspeção"/>


    <t-input-person customer
                    v-model="form.customerId"/>


    <t-input-code-label enterprise
                        v-model="form.enterpriseId"/>


    <t-input-code-label inspector
                        v-model="form.inspectorId"/>


    <t-input-search v-model="form.statusChecklist" placeholder="Todas" :options="StatusChecklistType.list"
                    label="Status Inspeção" select/>


  </t-report-generate>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageReportItemMixin from "@/mixins/page/pageReportItemMixin"
import StatusChecklistType from "@/model/types/modules/checklist/StatusChecklistType";

export default {

  mixins: [pageDefaultMixin, pageReportItemMixin],
  name: 'ReportExtractChecklist',
  data() {
    return {
      StatusChecklistType,
      path: "checklist/report", //Path padrão para validação, porém página foi configurada para validação direta na mesma página (validationOtherPageId)
      form: {
        issueDate: "",
        customerId: 0,
        enterpriseId: 0,
        inspectorId: 0,
        statusChecklist: 0,
      },

    }
  },
  props: {},
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {



    },


  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
